export const awardsDictionary = {
  more: "Ko'proq",
  deadlineFinished: 'Vazifa muddati tugagan',
  enoughCoin: 'Kumushingiz yetarli',
  buying: 'Sotib olish',
}
